/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Call_EyebrowInputs */

const en_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call it`)
};

const zh_hans1_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调用方式`)
};

const pt_br2_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como chamar`)
};

const es_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llámalo`)
};

const fr_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’appeler`)
};

const de_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufen`)
};

const ru_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вызвать`)
};

const it_endpoint_call_eyebrow = /** @type {(inputs: Endpoint_Call_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiamalo`)
};

/**
* | output |
* | --- |
* | "Call it" |
*
* @param {Endpoint_Call_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_call_eyebrow = /** @type {((inputs?: Endpoint_Call_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Call_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_call_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_call_eyebrow(inputs)
	if (locale === "es") return es_endpoint_call_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_call_eyebrow(inputs)
	if (locale === "de") return de_endpoint_call_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_call_eyebrow(inputs)
	if (locale === "it") return it_endpoint_call_eyebrow(inputs)
	return en_endpoint_call_eyebrow(inputs)
});